import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Bruce Onyango </span>
            from <span className="purple"> Nairobi, Kenya.</span>
            <br />
            I am an experienced and detail-oriented software engineer with a proven track record of navigating complex challenges to meet critical deadlines.
            <br />
            I am always scouting for great solutions to our societal problems.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Chess
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Soccer
            </li>
            <li className="about-activity">
              <ImPointRight /> Hanging out with friends and family
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Code == Solution but Solution !== Code"{" "}
          </p>
          <footer className="blockquote-footer">Bruce Onyango</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
